let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eYCsl")).then(() => parcelRequire('l5x5G'));